/**
 * Sistema de permisos para roles de usuario
 * Define qué acciones puede hacer cada rol
 */

export const ROLES = {
  ADMINISTRADOR: 'administrador',
  ENCARGADO_SECTOR: 'encargado_de_sector',
  AFILIADO: 'afiliado'
};

export const PERMISSIONS = {
  // Usuarios
  EDIT_USER: 'edit_user',
  CREATE_USER: 'create_user',
  DELETE_USER: 'delete_user',
  
  // Afiliados
  VIEW_ALL_AFFILIATES: 'view_all_affiliates',
  VIEW_SECTOR_AFFILIATES: 'view_sector_affiliates',
  CREATE_AFFILIATE: 'create_affiliate',
  EDIT_AFFILIATE: 'edit_affiliate',
  DELETE_AFFILIATE: 'delete_affiliate',
  
  // Sectores
  VIEW_ALL_SECTORS: 'view_all_sectors',
  VIEW_SECTOR: 'view_sector',
  CREATE_SECTOR: 'create_sector',
  EDIT_SECTOR: 'edit_sector',
  DELETE_SECTOR: 'delete_sector',
  
  // Pagos/Cobrar
  CHARGE_ANY_SECTOR: 'charge_any_sector',
  CHARGE_OWN_SECTOR: 'charge_own_sector',
  VIEW_PAYMENTS: 'view_payments',
  
  // Reportes
  VIEW_ALL_REPORTS: 'view_all_reports',
  VIEW_SECTOR_REPORTS: 'view_sector_reports',
  
  // Notificaciones
  VIEW_NOTIFICATIONS: 'view_notifications',
  
  // Perfil
  VIEW_OWN_DATA: 'view_own_data',
  EDIT_OWN_DATA: 'edit_own_data',
  CHANGE_PASSWORD: 'change_password',
  
  // Logout
  LOGOUT: 'logout'
};

/**
 * Matriz de permisos por rol
 */
export const rolePermissions = {
  [ROLES.ADMINISTRADOR]: [
    // Usuarios
    PERMISSIONS.EDIT_USER,
    PERMISSIONS.CREATE_USER,
    PERMISSIONS.DELETE_USER,
    
    // Afiliados
    PERMISSIONS.VIEW_ALL_AFFILIATES,
    PERMISSIONS.CREATE_AFFILIATE,
    PERMISSIONS.EDIT_AFFILIATE,
    PERMISSIONS.DELETE_AFFILIATE,
    
    // Sectores
    PERMISSIONS.VIEW_ALL_SECTORS,
    PERMISSIONS.CREATE_SECTOR,
    PERMISSIONS.EDIT_SECTOR,
    PERMISSIONS.DELETE_SECTOR,
    
    // Pagos
    PERMISSIONS.CHARGE_ANY_SECTOR,
    PERMISSIONS.VIEW_PAYMENTS,
    
    // Reportes
    PERMISSIONS.VIEW_ALL_REPORTS,
    
    // Notificaciones
    PERMISSIONS.VIEW_NOTIFICATIONS,
    
    // Perfil
    PERMISSIONS.VIEW_OWN_DATA,
    PERMISSIONS.EDIT_OWN_DATA,
    PERMISSIONS.CHANGE_PASSWORD,
    
    // Logout
    PERMISSIONS.LOGOUT
  ],
  
  [ROLES.ENCARGADO_SECTOR]: [
    // Afiliados - solo su sector
    PERMISSIONS.VIEW_SECTOR_AFFILIATES,
    
    // Sectores - solo ver
    PERMISSIONS.VIEW_SECTOR,
    
    // Pagos - solo su sector
    PERMISSIONS.CHARGE_OWN_SECTOR,
    PERMISSIONS.VIEW_PAYMENTS,
    
    // Reportes - solo su sector
    PERMISSIONS.VIEW_SECTOR_REPORTS,
    
    // Notificaciones
    PERMISSIONS.VIEW_NOTIFICATIONS,
    
    // Perfil
    PERMISSIONS.VIEW_OWN_DATA,
    PERMISSIONS.EDIT_OWN_DATA,
    PERMISSIONS.CHANGE_PASSWORD,
    
    // Logout
    PERMISSIONS.LOGOUT
  ],
  
  [ROLES.AFILIADO]: [
    // Perfil
    PERMISSIONS.VIEW_OWN_DATA,
    PERMISSIONS.EDIT_OWN_DATA,
    PERMISSIONS.CHANGE_PASSWORD
  ]
};

/**
 * Verifica si un usuario tiene un permiso específico
 */
export const hasPermission = (userRole, permission) => {
  const permissions = rolePermissions[userRole] || [];
  return permissions.includes(permission);
};

/**
 * Obtiene todos los permisos de un usuario
 */
export const getUserPermissions = (userRole) => {
  return rolePermissions[userRole] || [];
};

/**
 * Obtiene los datos del usuario desde localStorage
 */
export const getUserData = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user;
  } catch {
    return null;
  }
};

/**
 * Verifica si el usuario está autenticado
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  const user = getUserData();
  return !!(token && user && user.id);
};
